import { HTMLProps } from 'react';

export const EmptyColumn: React.FC<{ index?: number } & HTMLProps<HTMLDivElement>> = ({
    className,
    index = 0,
    children,
}) => {
    return (
        <div
            className={`flex-1 shrink-0 flex p-8 bg-white text-gray-300 items-center justify-center text-center ${className}`}
        >
            {children ? <div>{children}</div> : <div>Geen informatie beschikbaar</div>}
        </div>
    );
};
